// Orquesta servicios y flujo principal del componente Fastbooking Lite.
import createDataSearchService from "./data-search-service";
import createFilterDomService from "./filter-dom-service";
import createLastSearchesService from "./last-searches-service";
import createRenderService from "./render-service";
import createUiService from "./ui-service";

const fastbookingLite = {
  searchService: null,
  filterService: null,
  lastSearchesService: null,
  renderService: null,
  uiService: null,

  props: {
    cssSelector: ".c-fastbooking-lite",
    dynamicClass: ".c-fastbooking-lite.dynamicLoading",
    wrapper: ".fb-lite-wrapper-JS",
    viewports: {
      desktop: 1024,
    },
    modifiers: {
      mainFbLiteOpen: "mod--fastbookingLite-open",
      fullMode: "mod--full-mode",
      liteMode: "mod--lite-mode",
      open: "mod--open",
      show: "mod--show",
      hide: "mod--hide",
      active: "mod--active",
      selectLite: "mod--select-lite",
      destinationInput: "mod--destination",
      destination: "mod--destinationModal",
      assistant: "mod--assistantsModal",
      structuralNode: "is-structural-node",
      assistantSelect: "mod--assistantsSelect",
      eventTypeSelect: "mod--eventTypesSelect",
      activeFastbookingLite: "mod--activeFastbookingLite",
      levels: {
        first: "mod--firstLevel",
        second: "mod--secondLevel",
        third: "mod--thirdLevel",
        fourth: "mod--fourthLevel",
      },
      blocks: {
        firstBlock: "mod--firstBlock",
        secondBlock: "mod--secondBlock",
      },
      filter: "mod--filter",
      highlight: {
        lightBlue: "mod--background-light-blue",
        grey: "mod--background-grey",
      },
      textStyle: {
        light: "mod--light",
      },
    },
    btns: {
      goBack: ".fb-lite-back-JS",
      closeSearch: ".fb-lite-closeSearch-JS",
      submit: ".fb-lite-submit-JS",
    },
    form: {
      group: ".fb-lite-groupForm-JS",
      inputDestination: ".fb-lite-destinations-JS",
      selects: ".fb-lite-select-JS",
      selectsValue: ".fb-lite-selectsValue-JS",
    },
    accordions: {
      header: ".fb-lite-modalHeader-JS",
      label: ".fb-lite-modalContentItem-JS",
      title: ".fb-lite-modalContentTitle-JS",
      text: ".fb-lite-modalText-JS",
    },
    modals: {
      modals: ".fb-lite-modal-JS",
      options: ".fb-lite-modalOptions-JS",
      destinations: {
        default: ".fb-lite-modalDefault-JS",
        empty: ".fb-lite-modalEmpty-JS",
        emptyResult: ".fb-lite-modalEmptyDest-JS",
        headerText: ".fb-lite-modalHeaderText-JS",
      },
      blocks: ".fb-lite-modalBlocks-JS",
    },
    icons: {
      accordionArrow: `
        <div class="svg-icon accordion-arrow">
          <span class="cmp-icon" data-cmp-src="/content/dam/barcelo/commons/icons/ui/arrow_blue.svg">
            <img loading="lazy" width="49" height="49" alt="" class="c-icon" src="/content/dam/barcelo/commons/icons/ui/arrow_blue.svg">
          </span>
        </div>
      `,
    },
    searchData: {},
    fuse: null,
    sourceTree: [],
    searchIndex: null,
    filteredTree: [],
    visibleDestinationIds: [],
    visibleHotelIds: [],
    lastSearchResult: null,
    loadingSearchDataPromise: null,
    selectedDestinationId: null,
    selectedMeetingPath: null,
    meetingDetailsByPath: {},
    meetingDetailsRequestsByPath: {},
    staticMeetingOptions: null,
    lastSearches: {
      storageKey: "barcelo_fastbooking_lite_last_searches",
      ttlMs: 30 * 24 * 60 * 60 * 1000,
      maxItems: 3,
      items: [],
      panel: ".fb-lite-recentSearchesPanel-JS",
      list: ".fb-lite-recentSearchesList-JS",
      showDestinationsBtn: ".fb-lite-showDestinations-JS",
      destinationTree: ".fb-lite-destinationTree-JS",
      firstBlockHeaderText: ".fb-lite-modalHeaderText-JS",
      forceDestinationsDataAttr: "fbLiteShowAllDestinations",
    },
  },

  getSearchService: function () {
    if (!this.searchService) {
      this.searchService = createDataSearchService(this);
    }

    return this.searchService;
  },

  getFilterService: function () {
    if (!this.filterService) {
      this.filterService = createFilterDomService(this);
    }

    return this.filterService;
  },

  getRenderService: function () {
    if (!this.renderService) {
      this.renderService = createRenderService(this);
    }

    return this.renderService;
  },

  getLastSearchesService: function () {
    if (!this.lastSearchesService) {
      this.lastSearchesService = createLastSearchesService(this);
    }

    return this.lastSearchesService;
  },

  getUiService: function () {
    if (!this.uiService) {
      this.uiService = createUiService(this);
    }

    return this.uiService;
  },

  initializeServices: function () {
    this.getSearchService();
    this.getFilterService();
    this.getRenderService();
    this.getLastSearchesService();
    this.getUiService();
  },

  loadStylesheet: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-fastbookingLite.css", this.props.dynamicClass);
  },

  getFastbookingItems: function () {
    return Array.from(document.querySelectorAll(this.props.cssSelector));
  },

  setupBreadcrumb: function () {
    const breadcrumb = document.querySelector("nav.cmp-breadcrumb");
    if (!breadcrumb) {
      return;
    }

    breadcrumb.classList.add("mod--fastbookingLite");
  },

  initFastbookingItem: function (fastbookingLiteItem) {
    this.changeDestinationStructureOnMobile(fastbookingLiteItem);
    this.manageFastbookingFields(fastbookingLiteItem);
    this.manageDestinationPopover(fastbookingLiteItem);
    this.submitInfo(fastbookingLiteItem);
    this.setAccessibilityByKeyboardOnLitemode(fastbookingLiteItem, window.innerWidth < this.props.viewports.desktop);
  },

  onWindowResize: function (fastbookingsLite) {
    fastbookingsLite.forEach((fastbookingLiteItem) => {
      this.changeDestinationStructureOnMobile(fastbookingLiteItem);
      this.setPopoversPosition(fastbookingLiteItem);
      this.setAccessibilityByKeyboardOnLitemode(fastbookingLiteItem, window.innerWidth < this.props.viewports.desktop);

      const destinationInput = fastbookingLiteItem.querySelector(this.props.form.inputDestination);
      this.updateRecentSearchesView(fastbookingLiteItem, destinationInput?.value || "");

      if (window.innerWidth >= this.props.viewports.desktop) {
        fastbookingLiteItem.classList.remove(this.props.modifiers.open);
      }
    });
  },

  registerResizeHandler: function (fastbookingsLite) {
    window.addEventListener("resize", () => {
      this.onWindowResize(fastbookingsLite);
    });
  },

  init: function () {
    this.initializeServices();
    this.loadStylesheet();

    const fastbookingsLite = this.getFastbookingItems();
    if (!fastbookingsLite.length) {
      return;
    }

    this.setupBreadcrumb();
    fastbookingsLite.forEach((fastbookingLiteItem) => this.initFastbookingItem(fastbookingLiteItem));
    this.registerResizeHandler(fastbookingsLite);
  },

  setAccessibilityByKeyboardOnLitemode: function (fastbooking, isMobile) {
    return this.getUiService().setAccessibilityByKeyboardOnLitemode(fastbooking, isMobile);
  },

  manageFastbookingFields: function (fastbooking) {
    return this.getUiService().manageFastbookingFields(fastbooking);
  },

  manageDestinationPopover: function (fastbooking) {
    return this.getUiService().manageDestinationPopover(fastbooking);
  },

  printMatchingOccurences: function (accordionLabel, destinationInputLowercase, itMatches = false) {
    return this.getUiService().printMatchingOccurrences(accordionLabel, destinationInputLowercase, itMatches);
  },

  toggleActiveElem: function (accordion) {
    return this.getUiService().toggleActiveElem(accordion);
  },

  setIconsOnMobile: function (defaultModal, matchedResult = false) {
    return this.getUiService().setIconsOnMobile(defaultModal, matchedResult);
  },

  filterDestinationInput: function (fastbooking, destinationInput) {
    return this.getFilterService().filterDestinationInput(fastbooking, destinationInput);
  },

  changeDestinationStructureOnMobile: function (fastbooking, defaultModalElem = null, filtering = false) {
    return this.getUiService().changeDestinationStructureOnMobile(fastbooking, defaultModalElem, filtering);
  },

  setPopoversPosition: function (fastbooking, currentSelect = null) {
    return this.getUiService().setPopoversPosition(fastbooking, currentSelect);
  },

  getHotelNodeId: function (hotel, parentId, index) {
    return this.getRenderService().getHotelNodeId(hotel, parentId, index);
  },

  getRootListFromBlock: function (block) {
    return this.getRenderService().getRootListFromBlock(block);
  },

  getLevelClassByDepth: function (depth) {
    return this.getRenderService().getLevelClassByDepth(depth);
  },

  countHotelsInSubtree: function (destinationNode) {
    return this.getRenderService().countHotelsInSubtree(destinationNode);
  },

  createArrowIconElement: function (arrowTemplateHtml) {
    return this.getRenderService().createArrowIconElement(arrowTemplateHtml);
  },

  renderDestinationTreeNode: function (destinationNode, depth, arrowTemplateHtml) {
    return this.getRenderService().renderDestinationTreeNode(destinationNode, depth, arrowTemplateHtml);
  },

  createAllHotelsListItem: function (defaultLabel, total) {
    return this.getRenderService().createAllHotelsListItem(defaultLabel, total);
  },

  flattenHotelsForRender: function (treeData) {
    return this.getRenderService().flattenHotelsForRender(treeData);
  },

  createHotelListItem: function (hotel, extraClassName = "") {
    return this.getRenderService().createHotelListItem(hotel, extraClassName);
  },

  renderHotelsListFromTree: function (hotelsRootList, treeData) {
    return this.getRenderService().renderHotelsListFromTree(hotelsRootList, treeData);
  },

  renderTreeFromSearchData: function (fastbooking) {
    return this.getRenderService().renderTreeFromSearchData(fastbooking);
  },

  getStoredSearches: function () {
    return this.getLastSearchesService().getStoredSearches();
  },

  saveCurrentSearch: function (payload) {
    return this.getLastSearchesService().saveCurrentSearch(payload);
  },

  renderRecentSearches: function (fastbooking) {
    return this.getLastSearchesService().renderRecentSearches(fastbooking);
  },

  applyRecentSearch: function (fastbooking, searchId) {
    return this.getLastSearchesService().applyRecentSearch(fastbooking, searchId);
  },

  updateRecentSearchesView: function (fastbooking, query = "") {
    return this.getLastSearchesService().updateRecentSearchesView(fastbooking, query);
  },

  showAllDestinationsFromRecent: function (fastbooking) {
    return this.getLastSearchesService().showAllDestinationsFromRecent(fastbooking);
  },

  resetRecentSearchesMode: function (fastbooking) {
    return this.getLastSearchesService().resetRecentSearchesMode(fastbooking);
  },

  ensureSearchDataLoaded: function (fastbooking) {
    return this.getSearchService().ensureSearchDataLoaded(fastbooking);
  },

  flattenSearchData: function (data) {
    return this.getSearchService().flattenSearchData(data);
  },

  buildSearchIndex: function (data) {
    return this.getSearchService().buildSearchIndex(data);
  },

  computeVisibleIds: function (fuseResults) {
    return this.getSearchService().computeVisibleIds(fuseResults);
  },

  buildScoreIndex: function (fuseResults, query) {
    return this.getSearchService().buildScoreIndex(fuseResults, query);
  },

  sortByScore: function (items, scoreAccessor) {
    return this.getSearchService().sortByScore(items, scoreAccessor);
  },

  buildFilteredTree: function (tree, visibleState, scoreIndex) {
    return this.getSearchService().buildFilteredTree(tree, visibleState, scoreIndex);
  },

  stripSearchMetadata: function (node) {
    return this.getSearchService().stripSearchMetadata(node);
  },

  escapeHtml: function (value) {
    return this.getSearchService().escapeHtml(value);
  },

  highlightTextByMatches: function (text, matches, keyName) {
    return this.getSearchService().highlightTextByMatches(text, matches, keyName);
  },

  applyHotelsVisibility: function (fastbooking, baseVisibleHotelIds = null) {
    return this.getFilterService().applyHotelsVisibility(fastbooking, baseVisibleHotelIds);
  },

  resetDestinationTreeState: function (fastbooking) {
    return this.getFilterService().resetDestinationTreeState(fastbooking);
  },

  getAncestorDestinationIds: function (destinationId) {
    return this.getFilterService().getAncestorDestinationIds(destinationId);
  },

  showSelectedDestinationTree: function (fastbooking, destinationId) {
    return this.getFilterService().showSelectedDestinationTree(fastbooking, destinationId);
  },

  expandPathToDestinationNode: function (destinationNode) {
    return this.getFilterService().expandPathToDestinationNode(destinationNode);
  },

  clearDestinationSearch: function (fastbooking, destinationInput) {
    return this.getFilterService().clearDestinationSearch(fastbooking, destinationInput);
  },

  applySearchResultToDomByIds: function (fastbooking, destinationInput, searchResult) {
    return this.getFilterService().applySearchResultToDomByIds(fastbooking, destinationInput, searchResult);
  },

  initFuseSearch: function () {
    return this.getSearchService().initFuseSearch();
  },

  doSearch: function (query) {
    return this.getSearchService().doSearch(query);
  },

  fetchSearchData: async function (fastbooking) {
    return this.getSearchService().fetchSearchData(fastbooking);
  },

  fetchMeetingDetails: async function (fastbooking, meetingPath, eventTypes = []) {
    return this.getSearchService().fetchMeetingDetails(fastbooking, meetingPath, eventTypes);
  },

  submitInfo: function (fastbooking) {
    return this.getUiService().submitInfo(fastbooking);
  },
};

export default fastbookingLite;
